import { render } from "./GardenTicketManagement.vue?vue&type=template&id=254da953&scoped=true"
import script from "./GardenTicketManagement.vue?vue&type=script&lang=js"
export * from "./GardenTicketManagement.vue?vue&type=script&lang=js"

import "./GardenTicketManagement.vue?vue&type=style&index=0&id=254da953&lang=scss&scoped=true"

import exportComponent from "/home/forge/app-ticket.grandigiardini.it/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-254da953"]])

export default __exports__